import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=372de25b&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=372de25b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372de25b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('372de25b')) {
      api.createRecord('372de25b', component.options)
    } else {
      api.reload('372de25b', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=372de25b&scoped=true", function () {
      api.rerender('372de25b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/layout/layout.vue"
export default component.exports